import { Injectable } from '@angular/core';
import { FileUpload } from '../models/fileUpload.model';
import { map } from 'rxjs/operators';
import { AngularFirestore } from '@angular/fire/firestore';
import * as firebase from 'firebase';

@Injectable({
  providedIn: 'root'
})
export class FileService {

  database = 'files';
  constructor(private afs: AngularFirestore) {
  }

  get ref() {
    return firebase.firestore().collection(this.database);
  }
  create(fileupload: FileUpload) {
        return this.ref.firestore.doc(this.database + '/' + fileupload.id).set(Object.assign({}, fileupload));
  }
  getFile(id: string) {
    try {
      return this.afs.collection<FileUpload>(this.database).doc(id).snapshotChanges().pipe(map(actions => {
        if (actions) {
          return actions.payload.data();
        } else {
          return null;
        }
      }));
    } catch (err) {
      return null;
    }
  }
  getFilePromise(id: string) {
    try {
      return this.afs.collection<FileUpload>(this.database).doc(id).snapshotChanges().pipe(map(actions => {
        if (actions) {
          return actions.payload.data();
        } else {
          return null;
        }
      })).toPromise();
    } catch (err) {
      return null;
    }
  }
}
